if(!customElements.get('product-bundle-item')) {
  class ProductBundleItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    allowDebug() {
      return this.classList.contains('debug');
    }

    init() {
      this.JSONScriptTag = this.querySelector(`script[type="application/json"]:first-of-type`);
      this.data = this.JSONScriptTag ? JSON.parse(this.JSONScriptTag.innerHTML) : {};
      this.allowDebug() && console.log(`product-bundle-item.js `, this.data);
      // always scrub the JSON from the front end, we will take what we get at render and use this as the source of truth.
      if(this.JSONScriptTag) this.removeChild(this.JSONScriptTag);
      // console.log(JSON.stringify(this.data));
      this.titleContainer = this.querySelector('.bundle-product__title');
      this.priceContainer = this.querySelector('.bundle-product__price');
      this.itemMessaging = this.querySelector('.bundle-product__messaging');
      this.optionGroups = this.querySelectorAll('.bundle-product__option');
      this.colorGroup = this.querySelector('.bundle-product__option.color-option');
      this.nonColorGroups = this.querySelectorAll('.bundle-product__option:not(.color-option)');
      this.selectedOptions = [];
      this.selectedValues = [];
      this.form = this.querySelector('.bundle-product__form');
      this.cartMessage = this.querySelector('.bundle-product__cart-error');
      this.submitButton = this.form?.querySelector('button[data-add-to-cart]');
      this.bundleContainer = this.closest('product-bundle-overview');
      this.initEventListenrs();
      this.variant = this.setVariant();
      // console.log(this.variant);
      this.updateState();
      this.dispatchEvent(new CustomEvent('product-bundle-item:initialized', {
        bubbles: true,
        detail: { variant: this.variant }
      }));
    }

    initEventListenrs() {
      // option change
      this.initOptionsListener();
      // color change
      this.addEventListener('product-color-select:change', this.handleSwatchChange);
      // add to cart
      this.form?.addEventListener('submit', this.submitToCart.bind(this));
    }

    updateATC() {
      if(!this.submitButton) return;

      // clear any cart messages.
      if(this.cartMessage){
        this.cartMessage.innerHTML = "";
        this.cartMessage.classList.remove('error');
        this.cartMessage.classList.add('hidden');
      }

      const buttonText = this.submitButton.querySelector('.button__text');

      if (this.variant?.available) {
        this.submitButton.classList.remove('disabled');
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        if (buttonText) {
          buttonText.innerHTML = this.submitButton.dataset.availableText;
        }
      } else {
        this.submitButton.classList.add('disabled');
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.setAttribute('aria-disabled', 'true');
        if (buttonText) {
          buttonText.innerHTML = this.submitButton.dataset.unavailableText;
        }
      }
    }

    async submitToCart(event){
      event.preventDefault();
      if(this.submitButton.getAttribute('aria-disabled')) return;
      if(Object.keys(this.variant).length == 0) return;
      try{
        const action = `${window.routes.cart_add_url}.js`;

        // set the ATC button to a loading state.
        if(this.submitButton){
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        // compile the item data being sent to cart.
        let properties = {};

        properties["_ord_type"] = this.getOrderType();

        if(this.variant.hasOwnProperty("final_sale") && this.variant.final_sale == true){
          properties["_Final Sale"] = true;
        }

        if(this.variant.hasOwnProperty("color")) {
          properties["_color_id"] = this.variant.color;
        }

        // disable applying the main bundle promotion on individual ATCs

        if(this.bundleContainer){
          // if we have a bundle container (and we should), add bundle properties to this item.
          properties["_gc:bundle-product"] = this.bundleContainer.bundleTitle;
          properties["_gc:bundle-ID"] = this.bundleContainer.generateBundleId();
          properties["_gc:bundle-length"] = this.bundleContainer.itemElements.length;
        }

        this.form.querySelectorAll(`input[type="hidden"][name^="properties["]`).forEach(el => {
          const propertyName = el.name.match(/\[([^)]+)\]/)?.[1];
          if (propertyName) properties[propertyName] = el.value;
        });

        const requestBody = { items: [{ id: this.variant.id, quantity: 1, properties: properties }] };

        // post to the cart.
        await fetch(action, {
          method: 'POST',
          body: JSON.stringify(requestBody),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          }})
          .then(res => res.json())
          .then((response) => {
            if(!response.hasOwnProperty('items')){
              if(this.cartMessage){
                this.cartMessage.innerHTML = `${response.message} - ${response.description}`;
                this.cartMessage.classList.add('error');
                this.cartMessage.classList.remove('hidden');
              }

              if(this.submitButton){
                this.submitButton.classList.remove('loading');
                this.submitButton.classList.remove('disabled');
                this.submitButton.removeAttribute('disabled');
                this.submitButton.removeAttribute('aria-disabled');
                this.submitButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
              }
              return;
            }

            const cartDrawer = document.querySelector('#shopify-section-cart-drawer cart-drawer');
            if(cartDrawer){
              cartDrawer.refresh();
              cartDrawer.open();
            }

            const quickview = this.closest('quickview-modal');
            if(quickview) quickview.close();

            if(this.submitButton){
              this.submitButton.classList.remove('loading');
              this.submitButton.classList.remove('disabled');
              this.submitButton.removeAttribute('disabled');
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
            }
          })
          .catch((error) => {
            console.error(error);
            if(this.cartMessage){
              this.cartMessage.innerHTML = `${response.message} - ${response.description}`;
              this.cartMessage.classList.add('error');
              this.cartMessage.classList.remove('hidden');
            }
          }
        );
      } catch(error){
        console.error(error);
      }
    }

    handleSwatchChange(event){
      this.allowDebug() && console.log("handleSwatchChange", event);
      // Check if the event's triggering element is a descendant of this component
      if (this.contains(event.target)) {
        // Handle the event, knowing it originated from a descendant <product-bundle-item>
        this.allowDebug() && console.log('ProductBundleItem color change detected in a child product-color-select', event.target);
        this.allowDebug() && console.log('ProductBundleItem color', event.detail.swatch.value);
        if(this.data.is_complex_product){
          this.allowDebug() && console.log("Complex product swatch change.");
          this.handleChildProductChange(event.detail.swatch);
        } else {
          this.handleOptionChange();
        }
      }
    }

    initOptionsListener() {
      // non-swatch option change event.
      this.optionGroups = this.querySelectorAll('.bundle-product__option');
      this.nonColorGroups = this.querySelectorAll('.bundle-product__option:not(.color-option)');
      this.nonColorGroups.forEach((optionGroup)=>{
        // console.log(optionGroup);
        const optionName = optionGroup.dataset.option;
        const optionKey = optionGroup.dataset.optionKey;
        const optionInputs = optionGroup.querySelectorAll('input[type="radio"]');
        optionInputs.forEach((optionInput) =>{
          optionInput.addEventListener("change", (event)=>{
            // console.log(`${optionKey}:${optionName} change to ${optionInput.value} for ${this.titleContainer.textContent}`);
            this.handleOptionChange();
          });
        });
      });
    }

    updateOptionAvailability() {
      this.allowDebug() && console.log('product-bundle-item.js updateOptionAvailability()');
      // Store the current selection for each option level in key value pair.
      let currentSelection = {};
      this.optionGroups.forEach(group => {
        const selectedRadio = group.querySelector('input[type="radio"]:checked');
        if (selectedRadio) {
          currentSelection[group.dataset.optionKey] = selectedRadio.value;
        }
      });
      this.allowDebug() && console.log('product-bundle-item.js currentSelection', currentSelection);
      // Loop through each option group and update availability and possible combinations
      this.optionGroups.forEach(group => {
        const radios = group.querySelectorAll('input[type="radio"]');
        const isColorOption = group.classList.contains('color-option');

        radios.forEach(radio => {
          let isAvailable;
          let isImpossibleCombination = false;

          if (isColorOption) {
            // For color options, check if all combinations with this color are unavailable
            isAvailable = this.data.variants.some(variant =>
              variant[group.dataset.optionKey] === radio.value && variant.available
            );
          } else {
            // For other options, check availability based on current selection with this option's value
            const tempSelection = { ...currentSelection, [group.dataset.optionKey]: radio.value };

            // Check if this combination is possible
            isImpossibleCombination = !this.data.variants.some(variant =>
              Object.keys(tempSelection).every(key => variant[key] === tempSelection[key])
            );

            // Determine availability based on current selection
            isAvailable = this.data.variants.some(variant => {
              return Object.keys(tempSelection).every(key =>
                variant[key] === tempSelection[key] && variant.available
              );
            });
          }

          // Update class based on availability and impossibility
          if (isImpossibleCombination) {
            radio.classList.add('impossible-combination');
            radio.setAttribute('tabindex', '-1'); // Make it unfocusable
            radio.setAttribute('disabled', ''); // Make it unfocusable
          } else {
            radio.classList.remove('impossible-combination');
            radio.removeAttribute('tabindex'); // Make it focusable
            radio.removeAttribute('disabled'); // Make it unfocusable
          }

          if (!isAvailable && !isImpossibleCombination) {
            radio.classList.add('option-unavailable');
          } else {
            radio.classList.remove('option-unavailable');
          }
        });
      });
    }

    updateState() {
      this.allowDebug() && console.log('product-bundle-item.js updateState()')
      this.updateATC();
      if (Object.keys(this.variant).length > 0) {
        // update card media
        this.updateMediaElement();
        this.updateProductUrls();
        this.updateProductPrice();
        if(this.variant.available){
          this.itemMessaging.innerHTML = "";
          this.itemMessaging.classList.add('hidden');
        } else {
          this.itemMessaging.innerHTML = "Sorry, this size is unavailable";
          this.itemMessaging.classList.remove('hidden');
        }
      } else {
        // console.log('No current variant found');
        // technically the customer has an impossible combo selected, but show the usual messaging.
        this.itemMessaging.innerHTML = "Sorry, this size is unavailable";
        this.itemMessaging.classList.remove('hidden');
        // clear price data.
        if(this.priceContainer){
          this.priceContainer.innerHTML = "";
        }
      }
      this.updateOptionAvailability();
    }

    handleOptionChange() {
      this.allowDebug() && console.log('product-bundle-item.js handleOptionChange()');
      this.variant = this.setVariant();
      this.updateState();
      // dispatch event for the parent component to react to
      this.dispatchEvent(new CustomEvent('product-bundle-item:variant-change', {
        bubbles: true,
        detail: { variant: this.variant }
      }));
    }

    async handleChildProductChange(trigger){
      this.allowDebug() && console.log(`handleChildProductChange`, trigger);
      if(!trigger) return;
      try {
        await Promise.all([
          this.getChildProductData(trigger),
        ]);
      } catch(error){
        console.error(error);
      }
    }

    async fetchChildProductData(handle) {
      this.allowDebug() && console.log(`ProductBundleItem fetchChildProductData(${handle})`);
      if(!handle) return;
      try{
        const response = await fetch(`${handle}?view=bundle-item-options`);
        const responseHTML = await response.text();
        return responseHTML;
      } catch (error) {
        console.error(error);
      }
    }

    async getChildProductData(trigger) {
      this.allowDebug() && console.log(`ProductBundleItem getChildProductData(${trigger.dataset.childProductUrl})`);
      if(!trigger) return;
      const variantData = await this.fetchChildProductData(trigger.dataset.childProductUrl);
      const html = new DOMParser().parseFromString(variantData, 'text/html');
      this.updateChildProductOptions(html.querySelector('.template-container'));
      return Promise.resolve();
    }

    updateChildProductOptions(html){
      this.allowDebug() && console.log('updateChildProductOptions', html);
      if(!html) return;
      // before replacing content, get the current selected options so we can try to deep link.
      const currentOptionGroups = this.querySelectorAll(".bundle-product__option:not(.color-option)");
      let currentSelection = {};
      currentOptionGroups.forEach(group => {
        const selectedRadio = group.querySelector('input[type="radio"]:checked');
        if (selectedRadio) {
          currentSelection[group.dataset.optionKey] = selectedRadio.value;
        }
      });
      // grab the new HTML we want to inject, and inject it.
      this.optionsArea = this.querySelector('.bundle-product__options:not(.bundle-product__swatches)');
      this.optionsArea.innerHTML = html.innerHTML;
      // re-init the option events.
      this.initOptionsListener();
      // Try to re-select previously selected options in the new HTML.
      Object.keys(currentSelection).forEach(optionKey => {
        const valueToSelect = currentSelection[optionKey];
        const newOptionGroup = this.optionsArea.querySelector(`.bundle-product__option[data-option-key="${optionKey}"]`);
        const matchingRadio = newOptionGroup.querySelector(`input[type="radio"][value="${valueToSelect}"]`);

        if (matchingRadio) {
          // Uncheck the currently selected radio in the group.
          const currentlySelected = newOptionGroup.querySelector('input[type="radio"]:checked');
          if (currentlySelected) {
            currentlySelected.checked = false;
          }

          // Check the matching radio.
          matchingRadio.checked = true;
        }
      });
      // update the component variant based on current selected options
      this.handleOptionChange();
    }

    updateMediaElement() {
      const mediaContainer = this.querySelector('.bundle-product__media');
      const mediaWrapper = mediaContainer?.querySelector('a');
      const newMedia = this.variant?.featured_media_html;
      if (mediaWrapper && newMedia) {
        if (mediaWrapper?.innerHTML != newMedia) {
          mediaWrapper.innerHTML = newMedia;
        }
      }
    }

    updateProductUrls() {
      const productURLs = this.querySelectorAll('.bundle-product__url');
      const newURL = this.variant?.url || '#';
      productURLs.forEach((productURL)=>{
        productURL.href = newURL;
      });
    }

    updateProductPrice() {
      if(!this.priceContainer) return;
      if(!this.variant?.price_html) return;
      this.priceContainer.innerHTML = this.variant.price_html;
    }

    getSelectedOptionsTitle() {
      this.selectedOptions = this.getSelectedOptions();
      this.selectedValues = Array.from(this.selectedOptions).map(selectedOption => selectedOption.value);
      return this.selectedValues.join(" / ");
    }

    getSelectedOptions() {
      return this.querySelectorAll(".product__option-input:checked");
    }

    findMatchingVariant(selectedTitle) {
      if (!this.data.variants) return null;
      return this.data.variants.find(variant =>
        variant.title.toLowerCase() === selectedTitle.toLowerCase()
      ) ?? {};
    }

    setVariant() {
      return this.findMatchingVariant(this.getSelectedOptionsTitle());
    }

    getVariant() {
      return this.variant;
    }

    getOrderType() {
      return this.data.order_type || "WHP";
    }
  }

  customElements.define('product-bundle-item', ProductBundleItem);
}
